<template>
  <div class="wrap">
    <div class="place">
      <router-link class="link" to="./">首页</router-link>
      <div class="division">/</div>
      <div class="active">订单查询</div>
    </div>
    <div class="container">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item >
        <el-input v-model="formInline.order_n" placeholder="单号"></el-input>
      </el-form-item>
      <el-form-item >
        <div class="block">
          <el-date-picker
            v-model="value2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    </div>
  </div>
</template>

<script>
export default {
  // name: "order",
  data(){
    return {
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',
        formInline: {
          order_n: '',
          value2: ''
        }
    }
  },
  methods: {
    onSubmit(){

    }
  }
}
</script>
<style scoped>
.wrap {
    padding: 20px;
    width: 100%;
    height: 100%;
    background-color:#fff;
    box-sizing: border-box;
}
.place {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.division{
    padding:0 5px;
    color: #C0C4CC;
}
.link{
    text-decoration:none;
    color: #303133
}
.active{
   color: #909399; 
}
</style>